export default __webpack_public_path__ + "static/media/brace-symbol-bg-dark.18cd3fc1.svg";